<template>
   <v-container fluid class="pa-0 overflow-hidden" >
    <div class="margin-header"></div>
    <!-- class="ma-8  ma-sm-6 ma-md-4 ma-lg-8 ma-xl-16 " -->
      <!-- justify="left" v-bind:style="{ align:'left'}"  -->
      <v-row  justify="center" class="ma-0" :class="{'pl-8': $vuetify.breakpoint.smAndDown ,'pr-8': $vuetify.breakpoint.smAndDown }">
      <v-col class="homemaintitle_paragraph" v-bind:style="{ align:'left'}" justify="left" cols="12" md="5">
        <div align-center justify-center>
          <h2 class="display-6 fw-bold lh-1 mb-3 section-title" v-bind:style="{ color: '#000000'}">
            {{ this.lg_mainpage.title }}
          </h2>

          <p class="section-desc"  v-bind:style="{ color: '#000000',align:'left' }">
            {{ this.lg_mainpage.subtitle1 }}
          </p>
<br/>
    <v-row v-bind:style="{ alignContent:'center',align:'left' }" class="ma-0 d-flex justify-center align-center justify-md-start align-md-start"  >
       <!--  text-decoration-underline black--text -->
          <v-btn
                class="mb-1 mt-2 white--text slide-btn"
                height="45"
                @click="onClickMenu('/register-account')"
              >
                <h2 class="pa-6">{{ this.lg_mainpage.start_free }}
                  <!-- <v-icon >mdi-arrow-top-right</v-icon> -->
                </h2>
              </v-btn>
            </v-row>
        </div>
      </v-col>

        <v-col v-bind:style="{ align:'left'}" justify="left" cols="12" md="5">
             <v-img
          class="white--text align-end"
          height="350"
          src="@/assets/hpg-meeting.png"
        >
        </v-img>
        </v-col>
    </v-row>

     <v-row
    class="why-choose-section homepricing_paragraph"
    :class="{'pl-8': $vuetify.breakpoint.smAndDown ,'pr-8': $vuetify.breakpoint.smAndDown }"
    justify="center"
    :style="{ backgroundColor: '#F8F9FA' }"
  >
    <v-col cols="12" class="py-16">
      <div class="text-center mb-10">
       <h2 class="display-6 fw-bold lh-1 mb-3 section-title" v-bind:style="{ color: '#000000'}">
        {{ lg_mainpage.title_page2 }}
      </h2>
      </div>
 
      <v-row justify="center" class="cards-row mx-auto" style="max-width: 1500px;">
        <!-- Card 1: Professional & Educational Friendly -->
        <v-col cols="12" sm="6" md="3"
          v-for="(card, index) in cards"
          :key="index"
          class="d-flex"
        >
          <div
            class="why-card"
            :class="{ 'is-hovered': hoveredCard === index }"
            @mouseenter="hoveredCard = index"
            @mouseleave="hoveredCard = null"
          >
            <div class="card-icon-wrapper">
              <div class="card-icon-circle">
                <v-icon size="28" color="#1a3e6e">{{ card.icon }}</v-icon>
                <!-- <v-icon
                  v-if="card.badgeIcon"
                  class="badge-icon"
                  size="16"
                  :color="card.badgeColor || 'green'"
                >{{ card.badgeIcon }}</v-icon> -->
              </div>
            </div>
 
            <h3 class="card-title" v-html="card.title"></h3>
 
            <p v-if="card.description"  class="section-desc" >{{ card.description }}</p>
 
            <ol v-if="card.list" class="card-list">
              <li v-for="(item, i) in card.list" :key="i">{{ item }}</li>
            </ol>
 
            <div class="get-started-wrapper" :class="{ 'show': hoveredCard === index }">
              <!-- href="#" -->
              <a @click="onClickMenu('/register-account')"  class="get-started-link">Get Started &gt;</a>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>

        <v-row class="homepricing_paragraph mt-16 mb-16 ma-0" justify="left" v-bind:style="{ align:'left'}" 
        :class="{'pl-8': $vuetify.breakpoint.smAndDown ,'pr-8': $vuetify.breakpoint.smAndDown }">
         <v-col v-bind:style="{ align:'left'}" justify="left" cols="12" xl="6" lg="6" md="6" sm="12" xs="12" >
             <v-img
          class="white--text align-end"
          src="@/assets/hpg-create.png"
        >
        </v-img>
        </v-col>

      <v-col v-bind:style="{ align:'left'}" justify="left" cols="12" xl="6" lg="6" md="6" sm="12" xs="12" class="homesection3title_paragraph">
        <div align-center justify-center >
          <h2 class="display-6 fw-bold lh-1 mb-3 section-title" v-bind:style="{ color: '#000000'}">
            {{ this.lg_mainpage.title_page3 }}
          </h2>

          <p class="section-desc" v-bind:style="{ color: '#000000',align:'left',fontSize:'18px' }">
            {{ this.lg_mainpage.detail_page3 }}
          </p>
          <br/>

            <!-- <ul>
              <li>
            <h2 class="ml-8" v-bind:style="{ color: '#000000',fontWeight:'400 !important',align:'left' }">
           {{ this.lg_mainpage.detail_page3sub_1 }}
          </h2>
          </li> 
           <li>
            <h2 class="ml-8" v-bind:style="{ color: '#000000',fontWeight:'400 !important',align:'left' }">
           {{ this.lg_mainpage.detail_page3sub_2 }}
          </h2>
          </li> 
           <li>
            <h2 class="ml-8" v-bind:style="{ color: '#000000',fontWeight:'400 !important',align:'left' }">
           {{ this.lg_mainpage.detail_page3sub_3 }}
          </h2>
          </li> 
          </ul> -->
          <div class="check-list">
  <div class="check-item" v-for="(item, i) in [
    lg_mainpage.detail_page3sub_1,
    lg_mainpage.detail_page3sub_2,
    lg_mainpage.detail_page3sub_3
  ]" :key="i">
    <v-icon color="#4A90D9" size="20">mdi-checkbox-marked-circle</v-icon>
    <p class="section-desc ma-0" style="color:#000000; margin-left:12px;">{{ item }}</p>
  </div>
</div>
              <br/>
              <p class="section-desc" v-bind:style="{ color: '#000000',align:'left' }">
            {{ this.lg_mainpage.detail_page3sub_4 }}
          </p>
          <v-row v-bind:style="{ alignContent:'center',align:'left' }" class="ma-0 d-flex justify-center align-center justify-md-start align-md-start"  >
                      <v-btn
                class="mb-1 mt-2 white--text slide-btn "
                height="45"
                @click="onClickMenu('/register-account')"
              >
                <h2 class="pa-6">{{ this.lg_header_menu.registerformeeting }}
                  <!-- <v-icon >mdi-arrow-top-right</v-icon> -->
                </h2>
              </v-btn>
            </v-row>
        </div>
      </v-col>
    </v-row>
    <!-- Privacy Dialog persistent-->
    <v-dialog v-if="showpop" v-model="privacyDlg" :max-width="maxwidthdialog">
      <v-card v-bind:style="{ padding: '1rem' }">
        <!-- <v-img height="200" contain src="../assets/privacypolicy4.png"></v-img> -->
        <v-card-title primary-title class="justify-center word-fix">
          <h3>{{ this.lg_policy.privacy_consent }}</h3></v-card-title
        >
        <!-- <v-divider class="mx-4"></v-divider> -->
        <v-card-text>
          <div class="mt-3">
            {{ this.lg_policy.text1 }}
            {{ this.lg_policy.text2 }}
          </div>
        </v-card-text>

        <v-card-actions style="justify-self: center;">
          <v-spacer></v-spacer>
          <v-btn
            :small="buttonsmall"
            color="#205295"
            light
           v-bind:style="{ color: '#ffffff' }"
            @click="onclickPrivacyDlg()"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            {{ this.lg_policy.accept }}
          </v-btn>

          <v-btn
            :small="buttonsmall"
            outlined
            color="#ffffff"
            v-bind:style="{ color: '#000000' }"
            @click="onclickNonPrivacyDlg()"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            {{ this.lg_policy.learn_more }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Privacy Dialog -->
     <back-to-top :threshold="400" :duration="600" />
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants";
import { lg_mainpage } from "./language/lg_header_mainpage.js";
import { lg_policy } from "./language/lg_policy";
import { feature } from "../services/constants.js";
import { lg_header_feature } from "./language/lg_header_feature.js";
import { lg_header_menu } from "./language/lg_header_menu.js";
import BackToTop from '@/components/core/Backtotop.vue';


export default {
  components: 
  { 
    BackToTop,
  },
  name: "main-page",
  data: () => ({
    hoveredCard: null,
      cards: [],
    showpop: false,
    dateNow: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .replace("T", " ")
      .substr(0, 16),
    margincardpriceplans: "mx-auto ml-0 mt-0 mr-0 mb-0",
    width: 420,
    width_emp: 600,
    text_fontsize: 30,
    privacy_sta: "false",
    privacyDlg: false
  }),
  async mounted() {
    this.$store.state.loadFooter = true;
    localStorage.removeItem(feature.GET_BUY_NOW);
    this.onResize();
    this.$forceUpdate();
    // this.$router.go(); // Refreshes page
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      this.$router.push("/listroom");
      const response = await api.checkIfUserAgreed(userId);
      if (!response || !response.data || !response.data.id) {
        this.privacyDlg = true;
      } else {
        // this.$router.push("/create-meet-room");
      }
    } else {
      try {
        if (this.$store.state.checklinkmeeting === true) {
          throw new Error(this.lg_mainpage.contentmeeterror);
        }

        if (this.$store.state.checkidmeeting === true) {
          this.$swal.fire(
            this.lg_mainpage.titlemeeterror,
            this.lg_mainpage.contentmeetiderror,
            "error"
          );
        }
      } catch (error) {
        if (error.response?.status === 404) {
          this.$swal.fire(
            this.lg_mainpage.titlemeeterror,
            this.lg_mainpage.contentmeetiderror,
            "error"
          );
        } else {
          this.$swal.fire(
            this.lg_mainpage.titlemeeterror,
            error?.message,
            "error"
          );
        }
      }
      this.privacyDlg = true;
    }

    const titleEl = document.querySelector(".homemaintitle_paragraph");
if (titleEl) {
  setTimeout(() => {
    titleEl.classList.add("homemaintitle_paragraph--visible");
  }, 200); // delay เล็กน้อยให้ดู smooth
}


    const paragraphs = document.querySelectorAll(".homepricing_paragraph");
document.addEventListener("scroll", function(){
  paragraphs.forEach((paragraph)=>{
    if(isInView(paragraph)){
      paragraph.classList.add("homepricing_paragraph--visible");
    }else {
      paragraph.classList.remove("homepricing_paragraph--visible");
    }
  })
});



    const paragraphssection3 = document.querySelectorAll(".homesection3title_paragraph");
document.addEventListener("scroll", function(){
  paragraphssection3.forEach((paragraphssection3)=>{
    if(isInView(paragraphssection3)){
        setTimeout(() => {
   paragraphssection3.classList.add("homesection3title_paragraph--visible");
  }, 200); 
      
    }else {
      paragraphssection3.classList.remove("homesection3title_paragraph--visible");
    }
  })
});

this.cards=[
        {
          icon: 'mdi-video',
          title: this.lg_mainpage.detail_page2_2,
          description: this.lg_mainpage.detail_page2_1sub,
        },
        {
          icon: 'mdi-shield-check',
          title: this.lg_mainpage.detail_page2_3,
          description: this.lg_mainpage.detail_page2_3sub,
        },
        {
          icon: 'mdi-help-circle',
          title: this.lg_mainpage.detail_page2_4,
          list: [
            this.lg_mainpage.detail_page2_4sub_1,
            this.lg_mainpage.detail_page2_4sub_2,
            this.lg_mainpage.detail_page2_4sub_3,
            this.lg_mainpage.detail_page2_4sub_4,
          ],
        },
        {
          icon: 'mdi-account-check',
          badgeIcon: 'mdi-check-circle',
          badgeColor: '#4CAF50',
          title: this.lg_mainpage.detail_page2_1,
          description: this.lg_mainpage.detail_page2_1sub,
        },
      ];


      function isInView(element){
const rect = element.getBoundingClientRect();
return(
  rect.bottom > 0 &&
  rect.top < (window.innerHeight -350  || document.documentElement.clientHeight - 350 )
)
}
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  async beforeCreate() {
    this.$store.state.page_reload = false;
    // alert(localStorage.getItem("language"))
    // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_mainpage = lg_mainpage.lg_mainpage_th)
      : (this.lg_mainpage = lg_mainpage.lg_mainpage_en);

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_policy = lg_policy.policy_th)
      : (this.lg_policy = lg_policy.policy_en);

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_header_feature = lg_header_feature.lg_header_feature_th)
      : (this.lg_header_feature = lg_header_feature.lg_header_feature_en);

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_header_menu = lg_header_menu.lg_header_menu_th)
      : (this.lg_header_menu = lg_header_menu.lg_header_menu_en);

      

    // console.log("lg_login: " + JSON.stringify(this.lg_login));
  },
  created() {
    this.setpopupdialog("");
    this.onResize();
    this.$store.state.meetSta = false;
  },

  async beforeUpdate() {
    this.onResize();
  },

  computed: {
    widthheightimage(){
 switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "300";
        case "sm":
          return "400";
        case "md":
          return "400";
        case "lg":
          return "400";
        case "xl":
          return "400";
      }
      },
    maxwidthdialog() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "100%";
        case "sm":
          return "70%";
        case "md":
          return "40%";
        case "lg":
          return "30%";
        case "xl":
          return "30%";
      }
    },
    buttonsmall() {
      if (this.$vuetify.breakpoint.name === "xs") {
        return true;
      }
    },
  },
  methods: {
    async onclickPrivacyDlg() {
      if (api.isLoggedIn()) {
        const userId = localStorage.getItem(server.USER_ID);
        const username = localStorage.getItem(server.FULLNAME);
        if (userId) {
          const body = {
            account_id: userId,
            account_name: username,
            device_platform: "web",
          };
          try {
            const response = await api.createPDPA(body);
            if (response && response.data && response.data.id) {
              this.privacyDlg = false;
            }
          } catch (e) {
            console.log(e.message);
          }
        }
      } else {
        this.privacyDlg = false;
      }
      this.setpopupdialog("clicked");
    },
    onclickNonPrivacyDlg() {
      // this.$store.dispatch("doLogout");
      // this.privacyDlg = false;
      // this.setpopupdialog("clicked");
      window.open(`http://${window.location.host}/privacy-policy`);
    },
    async onResize() {
      if (this.$vuetify.breakpoint.xsOnly) {
        this.margincardpriceplans = "mx-auto ml-5 mt-5 mr-5 mb-5";
      } else if (this.$vuetify.breakpoint.smOnly) {
        this.margincardpriceplans = "mx-auto ml-5 mt-5 mr-5 mb-5";
      } else {
        this.margincardpriceplans = "mx-auto ml-0 mt-0 mr-0 mb-0";
      }
    },
    async setpopupdialog(data) {
      // 1 = 1day  / +7 is +time zone
      const day = 1 * 24;
      const setdateexpired = new Date(
        new Date().setHours(new Date().getHours() + (day + 7))
      )
        .toISOString()
        .replace("T", " ")
        .substr(0, 16);
      // const setdateexpired = "2022-04-01 14:51";

      if (data === "clicked") {
        this.showpop = false;
        this.$cookies.set(
          "sessionpopup",
          { name: "checkclickpopup", expired: setdateexpired },
          setdateexpired
        );
      } else {
        if (
          this.$cookies.get("sessionpopup") &&
          new Date(this.$cookies.get("sessionpopup").expired) <=
            new Date(this.dateNow)
        ) {
          this.showpop = true;
          this.$cookies.remove("sessionpopup");
        } else if (
          this.$cookies.get("sessionpopup") &&
          new Date(this.$cookies.get("sessionpopup").expired) >=
            new Date(this.dateNow)
        ) {
          this.showpop = false;
        } else {
          this.showpop = true;
        }
      }
    },
    onClickMenu(link) {
      // console.log(link);
      this.$router.push(link).catch((err) => {});
    },
  },
};
</script>

<style scoped>
/*
@media only screen and (max-width: 600px) {
  .v-card{
    margin-top:40px;
     margin-bottom:40px;
      margin-right:40px;
       margin-left:40px;
}
}
*/
@media only screen and (max-width: 375px)  {
  .homemain{
    margin-top: -50px;
    /* height:100vh !important; */
  }
  /* .homefeature{
    height:150vh !important;
  } */
  /* .homepricing{
    height:80vh !important;
  } */
  /* .homegettotouch{
    height:70vh !important;
  } */
}
  @media only screen and (min-width: 375px) and (max-width: 599px)  {
  /* .mainpage-container {
    margin-top:-150px;
  } */
  .v-application {
    margin-top:-50px;
    /* height: 110% !important; */
  }
  /* .homemain{
    height:90vh !important;
  } */
  /* .homefeature{
    height:130vh !important;
  } */
  /* .homepricing{
    height:80vh !important;
  } */
  /* .homegettotouch{
    height:70vh !important;
  } */
}

/* @media (max-width: 959px) {
  .homefeature{
    height: 40% !important;
  }
} */

@media only screen and (min-width: 600px) and (max-width: 960px)  {
  /* .homefeature{
    height:80vh !important;
  } */
}

@media (min-width: 960px) {
  .mainpage-container {
    margin-top: 3rem
  }
}

.v-main {
    overflow:auto;
    /* max-width: 100%;
    height: 100%;
    width: 100%;
    background-image: linear-gradient(to right top, #cbe9f8, #dcedfc, #ebf2fd, #f7f8fe, #ffffff) !important; */
}
/* .mainpage-container {
    margin-top: -20px;
  } */

.homemain{
    /* background: rgba(0,0,0,0.8) url("../assets/home.jpg"); */
    background-color: #ffffff;
    /* height: 50vh; */
    /* min-height:50vh; */
    width: 100%;
    background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-blend-mode: darken;
  align-content: center;
  /* filter: brightness(0.3); */
}
.homefeature{
  background-image: linear-gradient(to right top, #cbe9f8, #dcedfc, #ebf2fd, #f7f8fe, #ffffff) !important;
    /* height: 60vh; */
    width: 100%;
    align-content: center;
}
.homepricing{
  background-color: #afcbf8 !important;
    /* height: 50vh; */
    width: 100%;
    align-content: center;
}
.homegettotouch{
  background-color: #102c39 !important;
    /* height: 50vh; */
    width: 100%;
    align-content: center;
}

.homepricing_paragraph{
  transform: translateY(20px);
  opacity: 0;
  transition: 2s ease;
}
.homepricing_paragraph--visible{
  transform: translateY(0);
  opacity: 1;
}
/* .pricingimg{
  background-position: 'center';
  background-repeat: 'no-repeat';
  background-size: 'cover';
}
.fadein1s{
  animation: '1s fadeIn' 
} */
.margin-header{
/* margin-top: 0px; */
  height: 0vh;
}
@media (min-width: 600px) {
  .margin-header {
       /* padding:70px !important; */
    height: 20vh;
 
  }
}
.word-fix {
  word-break: normal;        /* ห้ามตัดกลางคำ */
  overflow-wrap: break-word; /* ถ้ายาวจริง ๆ ค่อยขึ้นบรรทัดใหม่ */
  white-space: normal;
}

.why-choose-section {
  font-family: 'Manrope', sans-serif;
}
 
 
.cards-row {
  gap: 0;
}
 
/* Card */
.why-card {
  background: #ffffff;
  border-radius: 16px;
  border: 2px solid transparent;
  padding: 36px 24px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  cursor: pointer;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
  position: relative;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
 
.why-card.is-hovered {
  border-color: #1a3e6e;
  box-shadow: 0 8px 28px rgba(26, 62, 110, 0.15);
  transform: translateY(-4px);
}
 
/* Icon */
.card-icon-wrapper {
  margin-bottom: 20px;
  position: relative;
  display: inline-block;
}
 
.card-icon-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #eef2f8;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
 
.badge-icon {
  position: absolute !important;
  bottom: 0px;
  right: -2px;
  background: white;
  border-radius: 50%;
}
 
/* Title */
.card-title {
  font-size: 17px;
  font-weight: 700;
  color: #0d2b52;
  line-height: 1.4;
  margin-bottom: 14px;
  min-height: 48px;
}
 
/* Description */
.card-desc {
  font-size: 14px;
  font-weight: 400;
  color: #555e6e;
  line-height: 1.65;
  margin-bottom: 8px;
}
 
/* List */
.card-list {
  list-style: decimal;
  padding-left: 18px;
  text-align: left;
  width: 100%;
}
 
.card-list li {
  font-size: 14px;
  color: #555e6e;
  line-height: 1.7;
}
 
/* Get Started */
.get-started-wrapper {
  margin-top: 14px;
  opacity: 0;
  transform: translateY(6px);
  transition: opacity 0.2s ease, transform 0.2s ease;
  pointer-events: none;
}
 
.get-started-wrapper.show {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}
 
.get-started-link {
  font-size: 14px;
  font-weight: 600;
  color: #1a3e6e;
  text-decoration: none;
}
 
.get-started-link:hover {
  text-decoration: underline;
}

.check-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.check-item {
  display: flex;
  align-items: center;
}

.homemaintitle_paragraph {
  opacity: 0;
  transform: translateX(-60px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.homemaintitle_paragraph--visible {
  opacity: 1;
  transform: translateX(0);
}

.homesection3title_paragraph {
  opacity: 0;
  transform: translateX(60px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.homesection3title_paragraph--visible {
  opacity: 1;
  transform: translateX(0);
}


</style>
